import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import { INTEGRATION_STATUSES, getCategoryLabels } from '../constants'

const IntegrationCard = ({ integration, onClick }) => {
  const { t } = useTranslation(['integrations'])
  const categoryLabels = getCategoryLabels(t)
  const getStatusConfig = (status) => {
    switch (status) {
      case INTEGRATION_STATUSES.AVAILABLE:
        return {
          text: t('integrations:statuses.available'),
          icon: 'checkmark',
          className: 'status-available',
        }
      case INTEGRATION_STATUSES.PENDING:
        return {
          text: t('integrations:statuses.pending'),
          icon: 'clock',
          className: 'status-pending',
        }
      case INTEGRATION_STATUSES.NO_API:
        return {
          text: t('integrations:statuses.doesNotOfferApi'),
          icon: 'cross',
          className: 'status-no-api',
        }
      default:
        return {
          text: status,
          icon: 'checkmark',
          className: 'status-default',
        }
    }
  }

  const statusConfig = getStatusConfig(integration.status)

  return (
    <div className="integration-card" onClick={onClick}>
      <div className="integration-card__content">
        <div className="integration-card__logo">
          <img
            src={integration.logo}
            alt={t('integrations:shared.logoAlt', { name: integration.name })}
            className="integration-card__logo-image"
          />
        </div>
        <div className="integration-card__details">
          <div className="integration-card__header">
            <div className={`integration-card__status ${statusConfig.className}`}>
              <span className="integration-card__status-text">{statusConfig.text}</span>
              <Icon
                icon={statusConfig.icon}
                className="integration-card__status-icon"
                width="9"
                height="9"
                viewBox={
                  statusConfig.icon === 'clock'
                    ? '0 0 35 35'
                    : statusConfig.icon === 'checkmark'
                      ? '0 0 30 30'
                      : '0 0 20 20'
                }
              />
            </div>
            <h3 className="integration-card__name">{integration.name}</h3>
          </div>
          <p className="integration-card__description">{integration.description}</p>
        </div>
      </div>
      <div className="integration-card__category">
        <span className="integration-card__category-text">
          {categoryLabels[integration.category] || integration.category}
        </span>
      </div>
    </div>
  )
}

IntegrationCard.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default IntegrationCard
